import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    // Get user details from your Redux store
    const user = useSelector(state => state?.user?.user);
    console.log('user:',user)
    const location = useLocation();

    // If no user is found in the state, redirect to login
    if (!user?._id && !user?.id) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;